<template>
	<div>
        <div class="bg-white rounded">
            <b-row class="justify-content-lg-center">
                <b-col>
                    <b-table id="workersTable" class="mb-1" responsive outlined borderless striped hover show-empty :empty-text="$t('app_table_empty_text')" :items="workers" :fields="fields" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:head(firstname)>
                            {{ $t('worker_label_firstname') }}
                        </template>
                        <template v-slot:head(lastname)>
                            {{ $t('worker_label_lastname') }}
                        </template>
                        <template v-slot:head(isActive)>
                            {{ $t('worker_label_is_active') }}
                        </template>
                        <template v-slot:head(actions)>
                            {{ $t('worker_label_actions') }}
                        </template>
                        <template v-slot:cell(isActive)="{ item }">
                            {{ item.isActive ? $t('app_yes') : $t('app_no') }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <a :href="`/worker/${item.id}`" type="button" class="btn btn-sm btn-info">{{ $t('worker_button_view') }}</a>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row class="justify-content-lg-center pl-2 pr-2">
                <b-col>
                    <label>
                        <small><b>{{ $t('app_table_label_per_page') }}</b></small>
                        <b-form-select size="sm" v-model="perPage" :options="perPageOptions" />
                    </label>
                </b-col>
                <b-col class="d-flex">
                    <b-pagination class="my-auto ml-auto" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="workersTable" /> 
                </b-col>
            </b-row>
        </div>
		<b-row class="justify-content-lg-center">
			<b-col>
                <hr />
                <a :href="`/worker/new`" type="button" class="btn btn-primary">{{ $t('worker_button_create') }}</a>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'WorkerIndex',
    props: ['workers'],
    data() {
        return {
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 25,
            currentPage: 1,
            fields: [
                { key: 'firstname', sortable: true },
                { key: 'lastname', sortable: true },
                { key: 'isActive', sortable: true },
                { key: 'actions', sortable: false },
            ],
        }
    },
    computed: {
        rows() {
            return this.workers ? this.workers.length : 0;
        }
    },
}
</script>
